import tabby from 'tabby';

let el = '.js-tabby';

// https://github.com/cferdinandi/tabby#options-and-settings
/*
let config = {
  selectorToggle: '[data-tab]',
	selectorToggleGroup: '[data-tabs]',
	selectorContent: '[data-tabs-pane]',
	selectorContentGroup: '[data-tabs-content]',
	toggleActiveClass: 'active',
	contentActiveClass: 'active',
	initClass: 'js-tabby',
	stopVideo: true,
}
*/

function init() {
  // check for el
  if (!document.body.contains(document.querySelector(el))) {
    return;
  }

  // run tabby
  tabby.init();
}

export default {
  init,
}



// WEBPACK FOOTER //
// ./scripts/comps/tabby.js